///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';

import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';
import { GtthStyleDirectivesModule } from './directives/style-directives/style-directives.module';
import { ButtonsDirectivesModule } from './directives/buttons-directives/buttons-directives.module';
import { ActionIconDirectivesModule } from './directives/action-icon-directives/action-icon-directives.module';

@NgModule({
    imports: [GtthStyleDirectivesModule, ButtonsDirectivesModule, ActionIconDirectivesModule, HasAnyAuthorityDirective],
    exports: [GtthStyleDirectivesModule, HasAnyAuthorityDirective, ButtonsDirectivesModule, ActionIconDirectivesModule]
})
export class GtthShareDirectivesModule {}
